import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, Box } from '@mui/material';
import { Home, Person, ListAlt } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import logo from '../../assets/images/encora_logo.png'; 

const drawerWidth = 340;

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
        backgroundColor: '#3B3B3D', 
        color: 'white',
    },
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
    color: 'white',
    '&:hover': {
        backgroundColor: '#019FE2', 
    },
    padding: theme.spacing(2), 
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    color: 'white',
    fontSize: '2rem',
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '1.2rem',
    fontFamily: 'Montserrat, Arial, sans-serif',
}));

const Logo = styled('img')({
    width: '100%',
    height: 'auto',
    marginBottom: '20px',
});

function Sidebar() {
    return (
        <StyledDrawer
            variant="permanent"
            anchor="left"
        >
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" p={2}>
                <Logo src={logo} alt="Logo" />
                <Typography variant="h4" noWrap style={{ fontWeight: 'bold', fontSize: '1.5rem', fontFamily: 'Nunito, Arial' }}>
                    
                </Typography>
            </Box>
            <List>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <StyledListItem button>
                        <StyledListItemIcon><Home style={{ fontSize: '2.5rem' }} /></StyledListItemIcon>
                        <StyledListItemText primary="Home" />
                    </StyledListItem>
                </Link>
                <Link to="/patients" style={{ textDecoration: 'none' }}>
                    <StyledListItem button>
                        <StyledListItemIcon><Person style={{ fontSize: '2.5rem' }} /></StyledListItemIcon>
                        <StyledListItemText primary="Patients" />
                    </StyledListItem>
                </Link>
                <Link to="/protocols" style={{ textDecoration: 'none' }}>
                    <StyledListItem button>
                        <StyledListItemIcon><ListAlt style={{ fontSize: '2.5rem' }} /></StyledListItemIcon>
                        <StyledListItemText primary="Protocols" />
                    </StyledListItem>
                </Link>
            </List>
        </StyledDrawer>
    );
}

export default Sidebar;
